import { render, staticRenderFns } from "./blog-23.vue?vue&type=template&id=f62df02c&scoped=true"
import script from "./blog-23.vue?vue&type=script&lang=js"
export * from "./blog-23.vue?vue&type=script&lang=js"
import style0 from "./blog-23.vue?vue&type=style&index=0&id=f62df02c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62df02c",
  null
  
)

export default component.exports